import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';

//MUI
import { Backdrop, Box, Button, Chip, CircularProgress, FormControl, FormControlLabel, Grid, LinearProgress, ListItem, OutlinedInput, Radio, RadioGroup, Stack,Typography } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { API } from "../../config";
import asyncForEach, {
    getAPI
    ,bytesToSize
    ,fni18n
} from "../../services/commonService";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import USelectBox from "../../components/mui/USelectBox";
import UButton from "../../components/mui/UButton";
import UTable from "../../components/mui/UTable";
import UAuthButton from "../../components/mui/UAuthButton";
import UAlertDialog from "../../components/mui/UAlertDialog";
import UConfirmDialog from "../../components/mui/UConfirmDialog";

import { FileService } from "../../services/FileService";
import AuthenticationService from "../auth/AuthenticationService";
import { HttpStatusCode } from "axios";
import { useRef } from "react";
import { DatePicker } from "@mui/x-date-pickers";

function LinearProgressWithLabel(props) {
  return (<>
    <Box sx={{ width: '100%', mr: 1 }}>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box></>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
export default function ProgramPage({history}){
  const userLoginId = AuthenticationService.getLoggedInUserID();
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [branchs, setBranch] = useState([]);
  const [models, setModels] = useState([]);
  const date = new Date();
  const [search, setSearch] = useState({});
  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);	
  const [description, setDescription] = useState('');	
  const [uploadVersion, setUploadVersion] = useState('');	
  const [formData, setFormData ]  = useState({
    userId: AuthenticationService.getLoggedInUserID()
  });
  
  const [progress, setProgress] = useState(0);//AP다운로드 
  const timer = useRef(); //AP다운로드 결과표시를 위한 타이머

  const [isUploading, setIsUploading] = useState(false); // 파일업로드 or AP다운로드 중이면 true
  const [targetCount, setTargetCount] = useState(0); // AP다운로드 대상 기기의 수
  const [successCount, setSuccessCount] = useState(0); // AP다운로드 성공 기기의 수

  const [selectedRadioValue, setSelectedRadioValue] = useState('resv'); //파일업로드 모드
  const [reservDate, setReservDate] = useState(`${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}-${date.getFullYear()}`);
  const [formOpen, setFormOpen ] = useState(false); //파일업로드 팝업
  const [jarFormOpen, setJarFormOpen ] = useState(false); //서버 배포 팝업

  const [alertOpen, setAlertOpen ] = useState(false);       //Alert 팝업 Open
  const [confirmOpen, setConfirmOpen ] = useState(false);   //confirm 팝업 Open
  const [ alertMsg, setAlertMsg ] = useState("");           // Alert message

  const [machineNo, setMachineNo] = useState([]);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [retailers, setRetailers] = useState([]);
  
  const columns = [
    { 
      field: 'id',
      headerName: 'No',
      width: 90,
      hide: true,
    },
    {
      field: 'checkBox',
      headerName: 'checkBox',
      width: 80,
      headerAlign: "center",
      align: "center",
      checkBox: true,
    },
    {
      field: 'storeCd',
      headerName: 'store Code',
      width: 80,
      hide: true,
    },
    {
      field: 'machId',
      headerName: '기기번호',
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'machKndCd',
      headerName: '기종',
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'machIp',
      headerName: 'IP',
      width: 130,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'machPort',
      headerName: 'PORT',
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'curVerNo',
      headerName: '현재버전',
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'upVerNo',
      headerName: '파일버전',
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'fileId',
      headerName: '파일ID',
      width: 90,
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: 'fileRealNm',
      headerName: '파일명',
      width: 120,
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: 'fileNm2',
      headerName: '파일',
      width: 140,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'fileCount',
      headerName: '파일 수',
      width: 120,
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: 'prgmDesc',
      headerName: '설명',
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'lastUpdDt',
      headerName: '파일업로드일자',
      width: 180,
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: 'reservDt',
      headerName: '다운로드예정일',
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'downloadDt',
      headerName: '다운로드실행일',
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'result',
      headerName: '결과',
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: 'updUserId',
      headerName: '등록자',
      width: 90,
      headerAlign: "center",
      align: "center",
    },
  ];
  //화면 로드 시
  useEffect(() => {
    const getLoadData = async () => {
      try {
        await Promise.all([
          loadComboBoxBranchGroup(),
          loadComboBoxBranch(),
          loadComboBoxModel()
        ]);
      } catch (e) {
        console.error('초기 로딩 실패:', e.message);
      }
    };
    getLoadData();
  }, []);
  
  useEffect(() => {
    if (!isFirstLoad) return;
    if (search.storeCd) {
      loadDataGrid(); 
      setIsFirstLoad(false);
    }
  }, [search]);
  
  useEffect(() => {
    if(progress>=100){
      timer.current = window.setTimeout(() => {
        handleBackdropClose();
        setProgress(0);
        setIsUploading(false);
        clearTimeout(timer.current);
        
        handleFormClose();
        history.go(0);
      }, 500);
    }
  }, [progress]);

  useEffect(()=>{

  }, [isUploading]);

  const clearSearchVal = ()=>{
    setSearch({
      ...search,
      ['storeCd']: 'N/A',
    });
    setMachineNo([]);
  }

  // 콤보박스 데이터
  const loadComboBoxBranchGroup = async () => {
    try {
      const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
      const _inputData = res.data.result.map((m) => ({
        cd: m.id,
        name: m.branchGroupNm,
      }));
      setRetailers(_inputData);
      // await loadComboBoxBranch(_inputData[0].cd);
    } catch (e) {
      console.error(e.message);
    }
  };
  const loadComboBoxBranch = async(param) => {
    try{
      const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
      const _inputData = res.data.result.map((m) => ({
        cd: m.storeCd,
        name: m.storeNm,
        })
      );
      setBranch(_inputData );
      if (_inputData.length > 0){
        setSearch({
          ...search,
          ['storeCd'] : _inputData[0].cd,
        })
        await loadComboBoxMachineNo(_inputData[0].cd);
      } else {
        clearSearchVal()
      }
    }catch(e){
      console.error(e.message);
    }
  };
  const loadComboBoxMachineNo = async (branch) => {
    try{
      const res = await getAPI(API.COMMON.MACHINE+branch);
      const _inputData = res.data.result.map((m) => ({
          cd: m.machId,
          name: m.machId,
        })
      );
      setMachineNo(_inputData );

    }catch(e){
      console.error(e.message);
    }
  };
  const loadComboBoxModel = async() => {
    try{
      const res = await getAPI(API.COMMON.MODEL);
      const _inputData = res.data.result.map((m) => ({
          cd: m.machKndCd,
          name: m.machKndCd,
      }));
      setModels(_inputData );
    }catch(e){
      console.error(e.message);
    }
  };

  //데이터그리드
  const loadDataGrid = async() => {
    const res = await getAPI(API.SYSTEM.PROGRAM,search);
    setRows(res.data.result);
  }

  //테이블 checked rows
  function onCheckedItems(checkedItems){
    const chkrows = rows.filter((r)=> checkedItems.includes(r.id)?r:null);
    setSelectedRows(chkrows);
  }

  function onButtonClick(dvsn){
    if(dvsn==="조회"){
      loadDataGrid();
    }
    else if(dvsn==="업로드"){
      const fileCnt = selectedFiles.length; 
      const machCnt = selectedRows.length;
      if(machCnt<1){
        setAlertMsg("선택된 기기가 없습니다. 기기를 선택해주세요.");//en,kr
        handleAlertOpen();
        return;
      }
      if(fileCnt<1){
        setAlertMsg("선택된 파일이 없습니다. 파일을 선택해주세요.");//en,kr
        handleAlertOpen();        
        return;
      }
      
      if(fileCnt>0) {
        if(selectedRadioValue==='now'){          
           setAlertMsg("파일업로드를 및 AP다운로드가 즉시 실행됩니다. 실행 하시겠습니까?");//en,kr
           handleConfirmOpen();
        }else{;
           setAlertMsg("예약 파일업로드를 실행하시겠습니까?");//en,kr
           handleConfirmOpen();
        }
      }
    } else if (dvsn === "서버 파일 업로드") {
      const fileCnt = selectedFiles.length; 
      if(fileCnt<1){
        setAlertMsg("선택된 파일이 없습니다. 파일을 선택해주세요.");//en,kr
        handleAlertOpen();        
        return;
      }
      const fileName = selectedFiles[0].file.name;

      let fileReg = "";

      if (fileName.indexOf(".jar") > 0) {
        fileReg = /^apms(.*?)\.(jar)$/;
      } else {
        fileReg = /^build/;
      }
      
      // jar file validation check
      if (fileName.match(fileReg) == null) {
        setAlertMsg("맞는 파일이 아닙니다. 파일을 다시 선택해주세요");
        handleAlertOpen();        
        return;
      }
      WriteJarFile();
      handleJarFormClose();

    }
  };
  
  //alert confirm ok 
  function onClickOk(){
    handleConfirmClose();
    if(selectedRadioValue==='now'){ 
      WriteFile();
    }else{
      ReservFile();
    }
  };

  const ReservFile = async() => {
    const fd = new FormData();
    
    Object.values(selectedFiles).forEach((f)=>(
      fd.append("file",f.file)
    ));

    fd.append("userId",AuthenticationService.getLoggedInUserID());
    fd.append("prgmDesc",description);
    fd.append("upVerNo",uploadVersion);
    const dateArray = reservDate.split('-');
    fd.append("resvDate", dateArray[2]+dateArray[0]+dateArray[1] + "000000");

    fd.append("machList", JSON.stringify(selectedRows));
    await FileService.files(API.SYSTEM.UPLOAD,fd).then((res)=>{      
      if(res.data.code === HttpStatusCode.Ok){
        setAlertMsg(`Successful upload of ${res.data.result.length} files`);//en
        handleAlertOpen();
        handleFormClose();
        history.go(0);
      }else{
        setAlertMsg(`Failed upload of ${res.data.result.length} files`);//en
        handleAlertOpen();
        handleFormClose();
        history.go(0);
      }
    });
  }

  const WriteFile = async() => {
    const fd = new FormData();
    
    Object.values(selectedFiles).forEach((f)=>(
      fd.append("file",f.file)
    ));

    fd.append("userId",AuthenticationService.getLoggedInUserID());
    fd.append("prgmDesc",description);
    fd.append("upVerNo",uploadVersion);
    const dateArray = reservDate.split('-');
    fd.append("resvDate", dateArray[2]+dateArray[0]+dateArray[1] + "000000");
    fd.append("machList", JSON.stringify(selectedRows));

    let message = "";
    const progNum = 100/selectedRows.length;
    setIsUploading(true);
    setProgress(0);
    setSuccessCount(0);
    setTargetCount(selectedRows.length);

    try{
      FileService.files(API.SYSTEM.UPLOAD,fd).then((res)=>{
        if(res && res.data.code === HttpStatusCode.Ok){
          const send = async()=>{
            
            await asyncForEach(selectedRows, async selRow => {
              handleBackdropOpen();
              const fileId = res.data.result[0].fileId;
              const fileSaveNm = res.data.result[0].fileSaveNm;
              const res2 = await getAPI(`https://${selRow.machIp}:${selRow.machPort}/svc/if/apdown?storeCd=${selRow.storeCd}&termId=${selRow.machId}&fileId=${fileId}`);
              setSuccessCount(prevCount => prevCount+1);
              //agent에서 api-server 호출하여 결과 전송하는걸로 변경하여 message 처리 x
              if(res2 && res2.status === HttpStatusCode.Ok){
              }else{
              }              
              setProgress((prevProgress) => (prevProgress >= 100 ? progNum : prevProgress + progNum));
            });  
          }
          send();
        }else{
          setAlertMsg(`Failed upload of ${res.data.result.length} files`);//en
          handleAlertOpen();
        }
      });
  
  }catch(e){
      console.log(e.message);
    }  
  }

  const WriteJarFile = async() => {
    const fd = new FormData();
    
    Object.values(selectedFiles).forEach((f)=>(
      fd.append("file",f.file)
    ));


    let message = "";
    const progNum = 100/selectedRows.length;
    setIsUploading(true);
    setProgress(0);
    setSuccessCount(0);
    setTargetCount(selectedRows.length);

    try{
      FileService.files(API.SYSTEM.JARUPLOAD,fd).then((res)=>{
        if(res && res.data.code === HttpStatusCode.Ok){
          setAlertMsg(`success server upload files`);//en
          handleAlertOpen();
        }else{
          setAlertMsg(`Failed upload of ${res.data.result.length} files`);//en
          handleAlertOpen();
        }
      });
  
  }catch(e){
      console.log(e.message);
    }  
  }
  
  const onSearchChange = (e) => {
    let {name, value} = e.target;
    setSearch({
      ...search,
      [name] : value==='ALL'?'':value,
    })    
    if (name === "bizTy") {
      loadComboBoxBranch(value);
    }
    //지점선택 후 기번 가져오기
    if (name === "storeCd") {
      loadComboBoxMachineNo(value);
    }
  }
  
  const onInputChange = (e) => {
    let {name, value} = e.target;
    if(name==="desc")setDescription(value);
    else if(name==="upVerNo")setUploadVersion(value);
    setFormData({
      ...formData,
      [name] : value,
    })
  }
  // 파일 업로드
  const fnBrowser = () => {
      const element = document.createElement('input');
      element.name = "file";
      element.type = "file";
      element.multiple = true;
      element.onchange = onSaveFiles;
      element.click();
  };
  // 서버 배포 업로드
  const fnjarBrowser = () => {
    const element = document.createElement('input');
    element.name = "file";
    element.type = "file";
    element.multiple = false;
    element.onchange = onSaveJar;
    element.click();
};

  const onSaveFiles = (e) => {
    const uploadFiles = Array.prototype.slice.call(e.target.files); // 파일선택창에서 선택한 파일들
    const _inputData = uploadFiles.map((m,i)=>({
        key: `file-+${i}`,
        label: `${m.name} (${bytesToSize(m.size)})`,
        file: m,
    }));
    setSelectedFiles(_inputData);
  };

  const onSaveJar = (e) => {
    const uploadFiles = Array.prototype.slice.call(e.target.files); // 파일선택창에서 선택한 파일들
    const _inputData = uploadFiles.map((m,i)=>({
        key: `file-+${i}`,
        label: `${m.name} (${bytesToSize(m.size)})`,
        file: m,
    }));
    setSelectedFiles(_inputData);
  };

  const handleDelete = (chipToDelete) => () => {
    setSelectedFiles((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
  };


  const handleChange = (event) => {
    setSelectedRadioValue(event.target.value);
  };

  //폼 팝업
  const handleFormOpen = () => {
    setFormOpen(true);
  };
  const handleJarFormOpen = () => {
    setJarFormOpen(true);
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };
  const handleJarFormClose = () => {
    setJarFormOpen(false);
  };

  //Alert Open
  const handleAlertOpen = () => {
    setAlertOpen(true);
  };
  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  //Confirm Open
  const handleConfirmOpen = () => {
    setConfirmOpen(true);
    return true;
  };
  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };

  const handleBackdropClose = () => {
    setBackdropOpen(false);
  };
  const handleBackdropOpen = () => {
    setBackdropOpen(true);
  };


  return(
  <div className="main-container">
    <Box className="header">
      {/* 상단메뉴명 */}
        <Grid container>
            <Grid item xs={10}>
                {/* 상단메뉴명 */}
                <UBreadCrumbs
                    title={"시스템관리"}
                    subtitle={"프로그램관리"}
                />
            </Grid>
            <Grid item xs={2}>
                {/* 툴바 버튼 */}
                <Stack 
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="flex-start"
                    spacing={5}
                >
                </Stack>
            </Grid>
      </Grid>
    </Box>
      <Box className="contents">
      {/* 조회조건 */}
        <TableContainer className="table-container">
          <Table className="table" size="small">
              <TableBody>
                  <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                      <TableCell className="table-cell">
                          <USelectBox
                              name="bizTy"
                              items={retailers}
                              onItemChange={onSearchChange}
                          />
                      </TableCell>
                      <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                      <TableCell className="table-cell">
                        {/* 점번 선택 */}
                        <USelectBox
                        name="storeCd"
                        items={branchs}
                        onItemChange={onSearchChange} 
                        defaultValue={search.storeCd}
                        />
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                    <TableCell className="table-cell">
                        <USelectBox
                        id="machId"
                        name="machId"
                        items={machineNo}
                        onItemChange={onSearchChange}/>
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('기종')}</TableCell>
                    <TableCell className="table-cell">
                        {/* 기번 선택 */}
                        <USelectBox
                        name="machKndCd"
                        items={models}
                        onItemChange={onSearchChange} 
                        />
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
      </TableContainer>
      <div className="search">
          <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
      </div>
        <UTable 
          onCheckedChange={onCheckedItems}
          columns={columns} 
          rows={rows}
          rowPerPage={11}
          toolbarAdd={     
            <>
              <UAuthButton icon="Upload" onButtonClick={handleJarFormOpen} >서버 파일 업로드</UAuthButton>
              &nbsp;
              <UAuthButton icon="Upload" onButtonClick={handleFormOpen}>업로드</UAuthButton></>
          } 
        />
        
      </Box> 
      
      {/* 팝업 */}
      <div>
        <Dialog
            open={formOpen}
            onClose={handleFormClose}
            aria-labelledby="draggable-dialog-title"
            fullWidth={true}
            maxWidth="md">
            <DialogTitle style={{ backgroundColor: "#F6F6F6", color:"#2F2F2F", borderBottom: "1px solid #444444", height:"50px", fontSize:"20px"}} id="draggable-dialog-title" onClose={handleFormClose}>
              <Typography>{fni18n('파일 업로드')}</Typography>
                <IconButton
                aria-label="close"
                onClick={handleFormClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}>
                <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
            <DialogContentText>
              {/* 파일업로드  */}              
              <div className="pop-container">
                <div className="contents">
                  <TableContainer className="table-container">
                    <Table className="table" size="small">
                      <TableBody>
                          <TableRow className="table-row-header">
                              <TableCell className="table-cell-title">{fni18n('모드')}</TableCell>
                              <TableCell className="table-cell" colspan={2}>
                                  {/* 모드 선택 */}
                                  <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={selectedRadioValue}
                                    onChange={handleChange}
                                  >
                                    <FormControlLabel value="now" control={<Radio />} label={fni18n('즉시')} />
                                    <FormControlLabel value="resv" control={<Radio />} label={fni18n('예약')} />
                                  </RadioGroup>
                              </TableCell>
                              <TableCell className="table-cell">
                                {/* 일자 선택 */}
                                {selectedRadioValue==="resv"?
                                  (<FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <DemoContainer components={['DateTimePicker']}>
                                        <DatePicker
                                          name="reservDate"
                                          value={dayjs(reservDate)}
                                          onChange= {(e)=>{
                                            setReservDate(`${String(e.$M+1).padStart(2,'0')}-${String(e.$D).padStart(2,'0')}-${String(e.$y)}`)
                                            }}/> 
                                      </DemoContainer>
                                    </LocalizationProvider>
                                  </FormControl>):(<></>)
                                }
                              </TableCell>
                          </TableRow>
                          <TableRow>
                          <TableCell className="table-cell-title">{fni18n('파일')}</TableCell>
                            <TableCell className="table-cell" colspan={3}>
                              <Button variant='text' color="primary" 
                                onClick={()=>fnBrowser()}>
                                {fni18n('파일선택')}
                              </Button>
                              {selectedFiles && selectedFiles.map((data) => {
                                let icon;
                                return (
                                    <ListItem key={data.key}>
                                        <Chip
                                        icon={icon}
                                        label={data.label}
                                        onDelete={handleDelete(data)}/>
                                    </ListItem>
                                );
                              })}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className="table-cell-title">{fni18n('버전')}</TableCell>
                            <TableCell className="table-cell" colspan={3}>
                              <OutlinedInput sx={{ mt: 1, width: "100%" }} variant="outlined"
                                name="upVerNo"
                                id="outlined-adornment-weight"
                                aria-describedby="outlined-weight-helper-text"
                                rows={1}
                                onChange={onInputChange}/>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className="table-cell-title">{fni18n('설명')}</TableCell>
                            <TableCell className="table-cell" colspan={3}>
                              <OutlinedInput sx={{ mt: 1, width: "100%" }} variant="outlined"
                                name="desc"
                                id="outlined-adornment-weight"
                                aria-describedby="outlined-weight-helper-text"
                                multiline
                                rows={1}
                                onChange={onInputChange}/>
                            </TableCell>
                          </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
              {/* END 파일업로드  */}
            </DialogContentText>
            </DialogContent>
            <DialogActions sx={{align: "center", backgroundColor:"#F6F6F6"}}>
                <UAuthButton variant="contained" color="primary" onButtonClick={onButtonClick}>업로드</UAuthButton>
                <UButton variant="outlined" onButtonClick={handleFormClose}>닫기</UButton>
            </DialogActions>
            
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={backdropOpen}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
        </Dialog>
      </div>
      {/* 서버배포 dialog */}
      <div>
        <Dialog
            open={jarFormOpen}
            onClose={handleJarFormClose}
            aria-labelledby="draggable-dialog-title"
            fullWidth={true}
            maxWidth="md">
            <DialogTitle style={{ backgroundColor: "#F6F6F6", color:"#2F2F2F", borderBottom: "1px solid #444444", height:"50px", fontSize:"20px"}} id="draggable-dialog-title" onClose={handleJarFormClose}>
              <Typography>{fni18n('서버 파일 업로드')}</Typography>
                <IconButton
                aria-label="close"
                onClick={handleJarFormClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}>
                <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
            <DialogContentText>
              {/* Jar파일업로드  */}              
              <div className="pop-container">
                <div className="contents">
                  <TableContainer className="table-container">
                    <Table className="table" size="small">
                      <TableBody>
                          <TableRow>
                          <TableCell className="table-cell-title">{fni18n('파일')}</TableCell>
                            <TableCell className="table-cell" colspan={3}>
                              <Button variant='text' color="primary" 
                                onClick={()=>fnjarBrowser()}>
                                {fni18n('파일선택')}
                              </Button>
                              {selectedFiles && selectedFiles.map((data) => {
                                let icon;
                                return (
                                    <item key={data.key}>
                                        <Chip
                                        icon={icon}
                                        label={data.label}
                                        onDelete={handleDelete(data)}/>
                                    </item>
                                );
                              })}
                            </TableCell>
                          </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
              {/* END 서버배포  */}
            </DialogContentText>
            </DialogContent>
            <DialogActions sx={{align: "center", backgroundColor:"#F6F6F6"}}>
                <UAuthButton variant="contained" color="primary" onButtonClick={onButtonClick}>서버 파일 업로드</UAuthButton>
                <UButton variant="outlined" onButtonClick={handleJarFormClose}>닫기</UButton>
            </DialogActions>
            
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={backdropOpen}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
        </Dialog>
      </div>
      {/* Alert 팝업  */}
      <UAlertDialog
        message={alertMsg}
        open={alertOpen}
        onClose={handleAlertClose}
        />
      {/* 확인 팝업  */}
      <UConfirmDialog
        message={alertMsg}
        open={confirmOpen}
        onClose={handleConfirmClose}
        onClickOk={onClickOk}
      />
  </div>
  );
}